// "A new version is ready — Reload": shown when the page learns its bundle is out of date (stale-build.ts).
//
// ⚠ A BUTTON, NOT A FORCED RELOAD. A GM mid-drag, a player mid-sheet, a table screen in a fight — none of them should
// have the page pulled out from under them. The page keeps its address, so reloading loses nothing but the moment.
import { useEffect, useState } from "react";
import { NEW_BUILD_EVENT } from "../lib/stale-build";

export function NewBuildBar() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const on = () => setReady(true);
    window.addEventListener(NEW_BUILD_EVENT, on);
    return () => window.removeEventListener(NEW_BUILD_EVENT, on);
  }, []);
  if (!ready) return null;
  return (
    <div className="newbuild" role="status">
      A new version of Compendium is ready.
      <button className="primary" onClick={() => window.location.reload()}>Reload</button>
      <button className="link" onClick={() => setReady(false)}>Later</button>
    </div>
  );
}
